import type workbenchZh from '../zh/workbench';

const workbench: typeof workbenchZh = {
  funnel_detail: 'View "{{label}}" details',
  open_purchase: 'Open plan purchase',
  today_overview: "Today's overview",
  shop_line: '{{region}} store · {{name}}',
  pending_replies: 'Awaiting reply',
  dm_chip: 'DMs {{value}}',
  email_chip: 'Emails {{value}}',
  dm_quota: 'DM quota',
  invite_quota: 'Invite quota',
  dm_quota_meta: '/ {{total}} today · {{remain}} left',
  email_this_month: 'Emails this month',
  unlimited: 'Unlimited',
  delivery_rate: 'Delivered {{rate}}%',
  authorized_shops: 'Authorized stores',
  plan_expire: '{{plan}} · expires {{date}}',
  plan_benefits: 'Plan benefits',
  per_month: '/ month',
  mail_remain: '{{remain}} left',
  addon_included: 'incl. add-ons {{extra}}',
  plan_quota: '{{emails}} emails · {{shops}} stores',
  addon_packages: 'Add-on packages',
  addon_empty: 'None',
  usage_invite: 'Invites',
  quota_reset_time: 'Quota reset time:',
  quota_reset_hint:
    'This marks the quota cycle: after this month’s quota is used up, it shows when the new quota arrives if the plan is renewed, or when the quota expires if it is not. On reset, invite, DM, and email quotas refresh. Store quota does not.',
  current_usage: 'Current usage:',
  usage_shop: 'Stores',
  usage_email: 'Emails',
  email_tag: 'Email',
  usage_rest: '/ {{limit}} ( incl. add-ons {{extra}} )',
  funnel: 'Outreach funnel',
  funnel_load_failed: 'Failed to load the outreach funnel',
  quick_outreach: 'Quick outreach',
  funnel_matchable: 'Matchable',
  funnel_pool: 'Creator pool',
  funnel_dm: 'DMs sent',
  funnel_dm_rate: 'Conversion {{rate}}%',
  funnel_emailed: 'Emails sent',
  funnel_dm_to_email: 'DM→email {{rate}}%',
  targeted_invite: 'Targeted invites',
  funnel_invite_rate: 'Invite rate {{rate}}%',
  funnel_accepted: 'Replied/accepted',
  funnel_total_rate: 'Overall conversion {{rate}}%',
  todos: 'To-do',
  pending_dms: '{{value}} DMs awaiting reply',
  pending_dms_meta: 'The latest message was sent by the creator',
  dm_tag: 'DM',
  pending_emails: '{{value}} emails awaiting reply',
  pending_emails_meta: 'The creator replied and is waiting on you',
  handle: 'Process',
  quick_entry: 'Shortcuts',
  quick_dm: 'Send DM',
  quick_email: 'Send email',
  quick_upgrade: 'Purchase/Upgrade',
  quick_hint: 'Stores are Southeast Asia only. After authorization you can send DMs, emails, and targeted invites'
};

export default workbench;
